import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useCoreDispatch } from '../../../store/CoreStore';
import { getWindowObject } from '../../../utils/window';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { OnCloseCallback } from '../types';

import { BlockingModalContent } from './BlockingModalContent';

export const ConnectionLostConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        connectionLostOnClose(dispatch);
      }}
    />,
  ];

  return (
    <BlockingModalContent actions={action}>
      <L10nText tk="NO_INTERNET" />
    </BlockingModalContent>
  );
};

export const connectionLostOnClose: OnCloseCallback = (): void => {
  const windowObject = getWindowObject();
  windowObject.location.reload();
};
